export default "__VITE_ASSET__5a7e7693__"